<template>
    <div>
        <div class="nav-wrap">
        <div class="nav-bg">
            <nav id="nav">
                <div class="n-left">
                    <div class="n-logo-wrap">
                        <img src="../assets/images/logo.png"/>
                    </div>
                    <h1>顺运宝</h1>
                </div>
                <div class="n-right">
                    <a class="menu-btn">
                        <svg t="1678974462272" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="32222" width="30" height="30"><path d="M394.72 221.18H169.44c-25.31 0-45.95 20.64-45.95 45.95V492.4c0 25.31 20.64 45.95 45.95 45.95h225.27c25.4 0 45.95-20.64 45.95-45.95V267.13c0.01-25.31-20.63-45.95-45.94-45.95z m3.08 271.23c0 1.68-1.4 3.08-3.08 3.08H169.44c-1.68 0-3.08-1.4-3.08-3.08V267.13c0-1.68 1.4-3.08 3.08-3.08h225.27c1.68 0 3.08 1.4 3.08 3.08v225.28zM394.72 579.08H169.44c-25.31 0-45.95 20.64-45.95 45.95V850.3c0 25.31 20.64 45.95 45.95 45.95h225.27c25.4 0 45.95-20.55 45.95-45.95V625.03c0.01-25.31-20.63-45.95-45.94-45.95z m3.08 271.32c0 1.68-1.4 3.08-3.08 3.08H169.44c-1.68 0-3.08-1.4-3.08-3.08V625.12c0-1.68 1.4-3.08 3.08-3.08l225.27-0.09c1.68 0 3.08 1.4 3.08 3.08V850.4zM760.65 579.08H535.37c-25.31 0-45.95 20.64-45.95 45.95V850.3c0 25.31 20.64 45.95 45.95 45.95h225.27c25.31 0 45.95-20.55 45.95-45.95V625.03c0.01-25.31-20.63-45.95-45.94-45.95z m3.07 271.32c0 1.68-1.4 3.08-3.08 3.08H535.37c-1.68 0-3.08-1.4-3.08-3.08V625.12c0-1.68 1.4-3.08 3.08-3.08l225.27-0.09c1.68 0 3.08 1.4 3.08 3.08V850.4zM886.92 300.01L728.24 141.33c-18.12-18.12-47.72-18.12-65.84 0L503.71 300.11c-18.12 18.12-18.12 47.72 0 65.84l158.68 158.68c9.15 9.06 21.01 13.64 32.97 13.64a46.51 46.51 0 0 0 32.88-13.64l158.68-158.77c18.12-18.12 18.12-47.73 0-65.85z" p-id="32223"></path>
                        </svg>
                    </a>
                    <ul class="n-menu">
                        <li><a class="n-menu-item" href="#nav">首页</a></li>
                        <li><a class="n-menu-item" href="#find">查件</a></li>
                        <li><a class="n-menu-item" href="#desc">功能</a></li>
                        <li><a class="n-menu-item" href="#develop">开发</a></li>
                        <li><a class="n-menu-item" href="#contact">联系</a></li>
                        <li class="n-menu-item-login"><a class="n-menu-item" style="cursor:pointer;" href="login">
                            <svg t="1678943344550" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4403" width="25" height="25">
                                <path d="M512 74.666667C270.933333 74.666667 74.666667 270.933333 74.666667 512S270.933333 949.333333 512 949.333333 949.333333 753.066667 949.333333 512 753.066667 74.666667 512 74.666667zM288 810.666667c0-123.733333 100.266667-224 224-224S736 686.933333 736 810.666667c-61.866667 46.933333-140.8 74.666667-224 74.666666s-162.133333-27.733333-224-74.666666z m128-384c0-53.333333 42.666667-96 96-96s96 42.666667 96 96-42.666667 96-96 96-96-42.666667-96-96z m377.6 328.533333c-19.2-96-85.333333-174.933333-174.933333-211.2 32-29.866667 51.2-70.4 51.2-117.333333 0-87.466667-72.533333-160-160-160s-160 72.533333-160 160c0 46.933333 19.2 87.466667 51.2 117.333333-89.6 36.266667-155.733333 115.2-174.933334 211.2-55.466667-66.133333-91.733333-149.333333-91.733333-243.2 0-204.8 168.533333-373.333333 373.333333-373.333333S885.333333 307.2 885.333333 512c0 93.866667-34.133333 177.066667-91.733333 243.2z" 
                                    p-id="4404">
                                </path>
                            </svg>
                            <span>登录</span>
                        </a></li>
                    </ul>
                </div>
            </nav>
            <div id="banner" class="banner-wrap">
                <div class="b-bg">
                    <div class="b-title">
                        <h2>跨境电商与跨境物流智能对接系统</h2>
                        <p>——好运从这里开始</p>
                    </div>
                    <div class="b-icon">
                        <img src="../assets/images/banner1.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="find" class="find">
        <div class="find-wrap">
            <p class="sub-head find-head">查件</p>
            <div class="find-content">
                <ul class="">
                    <li><a href="https://www.t-cat.com.tw/Inquire/trace.aspx" target="_blank"><img src="../assets/images/hm.png"/>黑猫货态查询</a></li>
                    <li><a href="https://www.hct.com.tw/Search/SearchGoods_n.aspx" target="_blank"><img src="../assets/images/xz.png"/>新竹货态查询</a></li>
                    <li><a href="http://www.kerrytj.com/zh/search/search_track.aspx" target="_blank"><img src="../assets/images/dr.png"/>大荣货态查询</a></li>
                    <li><a href="http://east-wind.com.tw" target="_blank"><img src="../assets/images/df.png"/>东风货态查询</a></li>
                    <li><a href="https://eservice.7-11.com.tw/E-Tracking/search.aspx" target="_blank"><img src="../assets/images/711.png"/>7-11货态查询</a></li>
                    <li><a href="https://www.famiport.com.tw/Web_Famiport/page/process.aspx" target="_blank"><img src="../assets/images/qj.png"/>全家货态查询</a></li>
                    <li><a href="https://ecservice.okmart.com.tw/Tracking/Search" target="_blank"><img src="../assets/images/ok.png"/>OK货态查询</a></li>
                    <li><a href="https://www.hilife.com.tw/serviceInfo_search.aspx" target="_blank"><img src="../assets/images/lrf.gif"/>萊爾富货态查询</a></li>
                    <li><a href="http://query2.e-can.com.tw/ECAN_APP/search.shtm" target="_blank"><img src="../assets/images/xp.png"/>虾皮宅配货态查询</a></li>
                    <li><a href="https://spx.tw/" target="_blank"><img src="../assets/images/xpddd.png"/>虾皮店到店货态查询</a></li>
                    <li><a href="https://b2b.cvs.com.tw/RutenOrderSearch/" target="_blank"><img src="../assets/images/lt.jpg"/>露天订单查询</a></li>
                    <li><a href="https://emap.pcsc.com.tw/emap.aspx" target="_blank"><img src="../assets/images/711ms.png"/>7-11门市查询</a></li>
                    <li><a href="https://www.family.com.tw/marketing/inquiry.aspx" target="_blank"><img src="../assets/images/qj.png"/>全家门市查询</a></li>
                    <li><a href="http://www.hilife.com.tw/storeInquiry_street.aspx" target="_blank"><img src="../assets/images/lrf.gif"/>萊爾富门市查询</a></li>
                    <li><a href="http://www.jd-168.com" target="_blank"><img src="../assets/images/jd.png"/>聚鼎货态查询</a></li>
                </ul>
            </div>
        </div>
    </div>
    <div id="desc" class="desc">
        <div class="desc-wrap">
            <p class="sub-head desc-head">功能</p>
            <div class="desc-inner">
                <div class="exp-wrap">
                    <p class="exp-title">
                        <svg t="1678985781067" class="icon" viewBox="0 0 1380 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="35036" width="150" height="150">
                            <path d="M1349.433037 443.743794l-139.336807-184.840944a151.262029 151.262029 0 0 0-125.528654-50.525283H878.700582v-22.281337C878.700582 83.790377 847.318419 0 745.95403 0H185.468587C83.162734 0 0 51.78057 0 154.086424v550.129328c0 100.422924 87.242415 142.161201 188.292982 145.299418a182.330371 182.330371 0 0 0 179.505976 174.171008c96.029421 0 162.559608-94.146491 167.266932-188.292982H941.46491c4.393503 94.146491 80.338339 188.292982 176.681581 188.292982s168.208397-94.146491 172.6019-188.292982H1380.815201V580.570028c0-49.583819 0-98.226172-31.382164-136.826234zM366.22985 961.235673A125.528655 125.528655 0 0 1 251.057309 831.627337a118.9384 118.9384 0 0 1 115.172541-123.331903v1.882929c59.626111 0 104.502605 62.764327 104.502605 128.666871s-38.28624 122.390438-104.502605 122.390439z m449.706405-188.292982h-282.439473c-27.302482-62.764327-94.146491-125.528655-167.266932-125.528655s-138.08152 62.764327-165.384003 125.528655h-8.473184c-58.998468 0-130.549801-9.414649-130.549801-68.099295v-55.860252L62.764327 150.634386c0-58.998468 55.860251-94.146491 114.544898-94.146491h568.644805C804.952498 56.801716 815.936255 117.683114 815.936255 176.681581z m296.561447 188.292982A116.741649 116.741649 0 0 1 1004.229237 839.472878c0-66.216365 42.052099-133.374196 108.268465-133.374196a125.528655 125.528655 0 0 1 115.486362 129.608336 121.135152 121.135152 0 0 1-115.486362 125.528655z m205.553171-188.292982h-40.169169c-27.302482-62.764327-91.322096-125.528655-165.384002-125.528655s-138.08152 62.764327-165.384003 125.528655H878.700582v-502.114619h207.12228c24.791909 0 48.01471 26.988661 62.764328 46.445603l139.96445 175.740116A139.650628 139.650628 0 0 1 1318.050873 580.570028z" p-id="35037"></path>
                            <path d="M1153.294514 490.503218H1004.229237v-117.683114c0-21.653693-11.297579-39.227705-32.951272-39.227704s-29.499234 17.574012-29.499234 39.227704v180.447441h211.829605c21.653693 0 39.227705-6.904076 39.227704-28.557769a35.461845 35.461845 0 0 0-39.541526-34.206558z" p-id="35038"></path>
                        </svg>
                        <span>物&nbsp;&nbsp;&nbsp;&nbsp;流</span>
                    </p>
                    <ul class="exp-desc">
                        <li>仓库管理</li>
                        <li>库存管理</li>
                        <li>入库出库</li>
                        <li>报价管理</li>
                        <li>财务账单管理</li>
                        <li>钱包管理</li>
                        <li>账单分发</li>
                        <li>欠费提醒</li>
                        <li>欠费限制出货</li>
                        <li>欠费禁用账号</li>
                        <li>组织架构管理</li>
                        <li>上下级管控</li>
                        <li>客户管理</li>
                        <li>同行管控</li>
                        <li>外援管理</li>
                        <li>数据管控</li>
                        <li>功能管控</li>
                        <li>消息管理</li>
                        <li>通知群发</li>
                        <li>在线聊天</li>
                        <li>异常通报</li>
                        <li>代客打包</li>
                        <li>代打包登记统计</li>
                        <li>代贴单登记统计</li>
                        <li>指定打包类型</li>
                        <li>指定运输方式</li>
                        <li>标记普特货</li>
                        <li>视图定制</li>
                        <li>高级搜索</li>
                        <li>单笔新增资料</li>
                        <li>表格批量导入资料</li>
                        <li>表格更新资料</li>
                        <li>导入PDF创建订单</li>
                        <li>同步店铺订单</li>
                        <li>分包加单</li>
                        <li>订单删除</li>
                        <li>订单取消恢复</li>
                        <li>详情分拆</li>
                        <li>编辑资料</li>
                        <li>预览详情编辑修改</li>
                        <li>批量更新</li>
                        <li>快速建单</li>
                        <li>品名管理</li>
                        <li>批量自动获取面单</li>
                        <li>批量上传PDF面单</li>
                        <li>上传面单原件</li>
                        <li>打包完成确认</li>
                        <li>打印拣货单</li>
                        <li>打印面单</li>
                        <li>打印标签</li>
                        <li>打印入仓标签</li>
                        <li>打印找货单</li>
                        <li>拣货单样式设置</li>
                        <li>打印提醒</li>
                        <li>快速打印</li>
                        <li>快递签收</li>
                        <li>快递管理</li>
                        <li>货物上架入库</li>
                        <li>无记录货物快录</li>
                        <li>库存分拣</li>
                        <li>快递分拣</li>
                        <li>打总包</li>
                        <li>录重</li>
                        <li>装袋</li>
                        <li>袋号智能识别</li>
                        <li>取消装袋</li>
                        <li>重复出货提醒</li>
                        <li>贴单核对</li>
                        <li>出货统计</li>
                        <li>导出列表</li>
                        <li>导出清关资料</li>
                        <li>导出航空资料</li>
                        <li>航空清关统计</li>
                        <li>导出物流记录</li>
                        <li>货态管理</li>
                        <li>物流跟踪</li>
                        <li>包裹回寄</li>
                        <li>弃件处理</li>
                        <li>电子秤设置</li>
                        <li>计重策略</li>
                        <li>面单催收</li>
                        <li>撤回催收</li>
                        <li>快捷打开物流记录</li>
                        <li>快捷打开预览详情</li>
                        <li>现货仓储操作</li>
                        <li>COD操作</li>
                        <li>视频操作指引</li>
                        <li>文档操作指引</li>
                    </ul>
                </div>
                <div class="eshop-wrap">
                    <p class="eshop-title">
                        <svg t="1678985922620" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="40882" width="150" height="150">
                            <path d="M887.68 567.253333c-72.96 60.586667-168.746667 114.986667-281.173333 155.946667-108.8 39.68-213.76 59.52-306.56 61.226667-1.92 0-2.773333 2.56-1.28 3.84C361.813333 841.813333 443.733333 874.666667 533.333333 874.666667c180.693333 0 330.24-132.48 357.76-305.493334 0.213333-1.92-1.92-3.2-3.413333-1.92zM205.866667 585.6c64 13.653333 179.84 13.44 334.933333-42.88 160.64-58.453333 250.24-136.106667 288.426667-187.733333 11.093333-14.933333 11.52-35.413333 0.853333-50.56C764.586667 210.773333 656.213333 149.333333 533.333333 149.333333 333.013333 149.333333 170.666667 311.68 170.666667 512c0 12.16 0.64 24.32 1.92 36.053333a42.666667 42.666667 0 0 0 33.28 37.546667z" p-id="40883"></path><path d="M971.733333 260.906667c-22.4-61.866667-90.026667-99.626667-183.253333-112.213334-9.6-1.28-14.506667 11.306667-6.613333 16.853334 23.893333 17.066667 45.866667 36.693333 65.92 58.666666 3.84 4.266667 8.746667 7.68 13.866666 10.24 25.386667 12.373333 42.88 28.8 49.92 48.213334 29.44 80.64-106.666667 231.893333-349.013333 320s-443.733333 59.733333-472.96-20.906667c-8.106667-22.613333-3.413333-50.56 13.013333-81.28 3.2-5.76 5.12-12.16 5.546667-18.773333 1.92-28.373333 6.826667-55.893333 14.08-82.56 2.56-9.386667-8.96-16.213333-15.786667-9.173334-69.76 72.32-100.48 148.906667-77.013333 213.546667 47.146667 129.28 290.773333 155.306667 555.093333 59.093333 264.106667-95.786667 434.346667-272.426667 387.2-401.706666z" p-id="40884"></path>
                        </svg>
                        <span>电&nbsp;&nbsp;&nbsp;&nbsp;商</span>
                    </p>
                    <ul class="eshop-desc">
                        <li>货物批量采购</li>
                        <li>快递单号自动获取</li>
                        <li>退件分拆合包转寄</li>
                        <li>库存自动匹配转寄</li>
                        <li>预览详情快递转寄</li>
                        <li>通知货运代打包</li>
                        <li>仓库管理</li>
                        <li>库存管理</li>
                        <li>入库出库</li>
                        <li>组织架构管理</li>
                        <li>上下级管控</li>
                        <li>数据管控</li>
                        <li>功能管控</li>
                        <li>消息管理</li>
                        <li>通知群发</li>
                        <li>在线聊天</li>
                        <li>异常订单处理</li>
                        <li>快递扫码打包</li>
                        <li>指定打包类型</li>
                        <li>指定运输方式</li>
                        <li>标记普特货</li>
                        <li>视图定制</li>
                        <li>高级搜索</li>
                        <li>单笔新增资料</li>
                        <li>表格批量导入资料</li>
                        <li>表格更新资料</li>
                        <li>导入PDF创建订单</li>
                        <li>店铺绑定</li>
                        <li>店铺归属人变更</li>
                        <li>店铺管理</li>
                        <li>同步店铺订单</li>
                        <li>分包加单</li>
                        <li>订单删除</li>
                        <li>订单取消恢复</li>
                        <li>详情分拆</li>
                        <li>编辑资料</li>
                        <li>预览详情编辑修改</li>
                        <li>批量更新</li>
                        <li>快速建单</li>
                        <li>品名管理</li>
                        <li>批量自动获取面单</li>
                        <li>批量上传PDF面单</li>
                        <li>打包完成确认</li>
                        <li>打印拣货单</li>
                        <li>打印面单</li>
                        <li>打印标签</li>
                        <li>打印入仓标签</li>
                        <li>打印找货单</li>
                        <li>拣货单样式设置</li>
                        <li>打印提醒</li>
                        <li>快递签收</li>
                        <li>快递管理</li>
                        <li>货物上架入库</li>
                        <li>无记录货物快录</li>
                        <li>库存分拣</li>
                        <li>快递分拣</li>
                        <li>打总包</li>
                        <li>贴单核对</li>
                        <li>通知收件</li>
                        <li>出货统计</li>
                        <li>导出列表</li>
                        <li>导出物流记录</li>
                        <li>货态管理</li>
                        <li>物流跟踪</li>
                        <li>包裹回寄</li>
                        <li>弃件处理</li>
                        <li>快捷打开物流记录</li>
                        <li>快捷打开预览详情</li>
                        <li>现货仓储操作</li>
                        <li>COD操作</li>
                        <li>视频操作指引</li>
                        <li>文档操作指引</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div id="develop" class="dev-wrap">
        <div class="develop-wrap">
            <p class="sub-head dev-head">
                <span class="dev-title">开发</span>
                <span class="dev-subtitle">在不断对系统功能进行优化升级、功能完善，保持系统的市场优越性、适应性和新颖性，保证系统功能强大的同时，提供专属功能定制开发服务，为您创造更多的不可能；</span>
            </p>
            <div class="dev-content">
                <ul>
                   <li>
                    <svg t="1678987481074" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="47854" width="40" height="40">
                        <path d="M511.992325 26.931373c-267.881097 0-485.039975 217.158878-485.039975 485.039975s217.158878 485.039975 485.039975 485.039975c267.87905 0 485.036905-217.159902 485.036905-485.039975S779.871375 26.931373 511.992325 26.931373zM511.992325 943.115831c-238.118236 0-431.150624-193.031365-431.150624-431.146531S273.874089 80.821747 511.992325 80.821747c238.113119 0 431.143461 193.031365 431.143461 431.147554S750.105445 943.115831 511.992325 943.115831z" p-id="47855"></path>
                        <path d="M404.204413 188.609659 619.777167 188.609659 565.883723 296.395524 458.097858 296.395524Z" p-id="47856"></path>
                        <path d="M409.129586 589.041654 614.947162 738.727815 646.723889 700.597379 639.65796 675.863045 428.252109 522.112312Z"  p-id="47857"></path>
                        <path d="M591.064218 505.786485 538.938024 323.343269 485.043556 323.343269 460.125027 410.55761Z" p-id="47858"></path>
                        <path d="M402.754389 611.351775 377.256668 700.597379 511.990279 862.275665 600.965729 755.506966Z"  p-id="47859"></path>
                        <path d="M453.751876 432.868755 434.627307 499.80219 629.937574 641.8463 600.782557 539.803229Z" p-id="47860"></path>
                    </svg>
                        <p>专业团队</p>
                        <span>专业团队，全天维护，实时跟进市场最新需求</span>
                   </li> 
                   <li>
                        <svg t="1678987406102" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="46738" width="40" height="40">
                            <path d="M736.232934 118.192202h-448.922521L62.848129 506.970675 287.309389 895.749148h448.922521l224.46126-388.778473L736.232934 118.192202zM714.634073 858.33945H308.90825l-202.862399-351.368775L308.909274 155.602924h405.725823l202.862399 351.368775L714.634073 858.33945z" p-id="46739"></path>
                            <path d="M702.027997 467.579759c-1.821492 0-3.613291 0.121842-5.377446 0.334811l-57.531092-89.131266c9.021454-11.03134 14.444974-25.115907 14.444974-40.445518 0-35.285136-28.706673-63.992833-63.992833-63.992833s-63.992833 28.707697-63.992833 63.992833c0 20.231974 9.448414 38.289216 24.153455 50.023965L432.361176 623.290191a57.620171 57.620171 0 0 0-6.604061-0.392148 57.306862 57.306862 0 0 0-12.382869 1.360744l-56.37615-88.752428a44.318876 44.318876 0 0 0 6.635801-23.387588c0-24.597821-19.941191-44.539012-44.539012-44.539012s-44.539012 19.941191-44.539011 44.539012 19.941191 44.539012 44.539011 44.539011c1.710912 0 3.397252-0.106484 5.057994-0.293855l56.384341 88.764715c-7.465148 9.655239-11.918025 21.757563-11.918025 34.907322 0 31.556146 25.581775 57.137921 57.13792 57.137921s57.137921-25.581775 57.137921-57.137921c0-15.254867-5.989729-29.102916-15.731998-39.349961l119.124962-238.438319a63.816725 63.816725 0 0 0 20.238117-2.214664l57.425632 88.967444a44.329115 44.329115 0 0 0-6.462764 23.117283c0 24.597821 19.941191 44.539012 44.539012 44.539011s44.539012-19.941191 44.539011-44.539011c0-24.596797-19.941191-44.537988-44.539011-44.537988zM564.48641 338.33881c0-13.831667 11.2525-25.08519 25.08519-25.08519s25.08519 11.253524 25.08519 25.08519-11.2525 25.08519-25.08519 25.085191-25.08519-11.253524-25.08519-25.085191z" p-id="46740"></path>
                        </svg>
                        <p>前沿技术</p>
                        <span>集群架构，跨境专线，软硬一体</span>
                   </li> 
                   <li>
                        <svg t="1678987581811" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="50592" width="40" height="40">
                            <path d="M515.530406 770.231319c4.366448 0 8.812713-0.267083 13.284561-0.800225 42.889833-5.14723 79.310324-35.124985 92.75452-76.437903 1.01205-3.093455-0.452301-6.40078-3.40761-7.760754-2.928702-1.359974-6.469342-0.186242-8.119935 2.586918-0.159636 0.267083-17.198707 27.79095-83.542718 36.752042-9.930163 1.333368-19.594267 2.02717-28.752858 2.02717-46.483684-0.026606-67.196425-17.548678-67.382667-17.709337-2.342348-2.080382-5.910617-2.133593-8.306176-0.106424-2.422166 2.02717-2.981914 5.547343-1.331321 8.241708C440.960037 749.82864 477.273081 770.231319 515.530406 770.231319zM872.252901 359.078145c-0.586354 0-1.118474 0.106424-1.677199 0.106424C831.705416 190.893678 683.175591 65.355497 505.09473 65.355497c-182.979428 0-334.916862 132.473127-368.595916 307.724547-32.745798 5.894244-57.665351 34.671661-57.665351 69.477374l0 139.300626c0 39.045271 31.309076 70.703295 69.965491 70.703295 21.804608 0 41.052998-10.29446 53.858652-26.110681 30.934546 81.82254 93.922113 147.803277 173.627433 182.610014 0.191358-0.415462 1.700735-3.348258 3.514033-5.685489 1.257643-1.620917 2.660596-2.952238 3.868097-2.952238 1.251503 0 2.396583 0.453325 3.381004 1.147126-18.450211-13.735839-85.086887-84.33271-99.516528-182.853561-6.336312-43.366693 26.143427-85.932138 63.975057-92.973508 60.727083-11.308557 121.134895-24.189935 181.861978-35.284621 38.603203-7.04137 64.987107-28.217668 81.120552-63.475683 3.780093-8.241708 9.238408-24.910343 11.741415-48.940642 0.665149-3.573385 3.593851-6.320962 7.348362-6.320962 2.503007 0 4.632507 1.280156 6.043646 3.120061l1.677199-1.039679c23.934109 34.751478 71.403237 111.695918 78.218456 192.827727 7.827269 92.76066 3.460822 156.289556-67.542302 221.285872-0.079818 0.079818-0.186242 0.186242-0.292666 0.267083-0.985444 1.066285-1.570775 2.453888-1.570775 3.973498 0 2.000564 1.065262 3.707438 2.609431 4.747117 0.585331 0.240477 1.171686 0.559748 1.757017 0.800225 0.478907 0.106424 0.931209 0.267083 1.411139 0.267083 0.479931 0 0.905626-0.159636 1.331321-0.267083 1.01205-0.533143 1.969864-1.147126 2.955308-1.680269 71.802326-39.552831 126.884852-105.615433 152.336524-185.066973 10.302647 15.308661 26.436092 26.323529 45.178969 30.163997-30.057573 136.713708-151.990646 222.272339-303.050084 235.261165-9.052167-22.456455-31.335682-38.405705-57.505715-38.405705-34.183544 0-61.898769 27.070542-61.898769 60.435441s27.714202 60.408835 61.898769 60.408835c27.554566 0 50.637284-17.709337 58.650795-42.032302 174.859493-14.21577 315.02993-118.150934 344.289324-279.640931 25.850761-10.80202 44.007283-36.165688 44.007283-65.769936L944.083879 430.42203C944.081833 391.029858 911.920342 359.078145 872.252901 359.078145zM807.744701 399.564231C762.140037 276.026614 643.960451 187.773617 504.935094 187.773617c-138.440026 0-256.192893 87.505983-302.224276 210.243375-2.289136-2.800789-4.978385-5.200442-7.614421-7.627724C221.160006 240.820788 349.882716 127.0977 505.09473 127.0977c154.467047 0 282.789645 112.602567 309.705668 261.131369C812.137755 391.803477 809.68796 395.537522 807.744701 399.564231zM376.292202 809.063743c-0.00307-0.001023-0.005117-0.002047-0.008186-0.00307C376.255363 809.125141 376.25434 809.133328 376.292202 809.063743z" p-id="50593"></path>
                        </svg>
                        <p>全天客服</p>
                        <span>技术客服，业务客服，物流客服，全天守候</span>
                </li> 
                </ul>
            </div>
        </div>
        <div class="develop-wrap" style="margin-bottom: 15px;text-align: center;">
            <p class="sub-head dev-head">
                <span class="dev-title">联系我们</span></p>
                <div class="ct-content">
                    <div class="ct-img-wrap">
                        <img src="../assets/images/wx-qrcode1.jpg"/>
                    </div>
                </div>
        </div>
    </div>
    <footer id="contact" class="footer">
        <div class="footer-wrap">
            <!-- <p class="contact-head">联系我们</p> -->
            <!-- <p class="contact-head1">请登录后查看联系方式</p> -->
            <!-- <div class="ct-content">
                <div class="ct-img-wrap">
                    <img src="../assets/images/wx-qrcode1.jpg"/>
                </div>
            </div> -->
            <div class="bk">
                <span>Copyright © 2006-2023 顺运宝 顺邦网络科技有限公司 <a href="https://beian.miit.gov.cn/">湘ICP备2023004561号 </a></span><br/>
                <!-- <span>技术支持 {{msg('微信：shunyunbaobao')}}</span> -->
            </div>
        </div>
    </footer>

    <el-dialog
        :title="msg('登录')"
        :visible.sync="loginVisiable"
        :close-on-click-modal="false"
        width="350px">
        <div class="wrap">
            <div class="input-wrap">
                <el-input :placeholder="msg('请输入用户名')" v-on:keyup.enter.native="focusPwd" prefix-icon="el-icon-s-custom" v-model="username" style="margin-bottom: 10px;"></el-input>
                <el-input type="password" :placeholder="msg('请输入密码')" ref="pwdRef" @keyup.enter.native="focusCode"  prefix-icon="el-icon-key" v-model="password" style="margin-bottom:10px;" show-password></el-input>
                <div style="margin-bottom:20px; display:flex;" >
                    <el-input :placeholder="msg('验证码')" ref="codeRef" @keyup.enter.native="login()" prefix-icon="el-icon-picture-outline-round" v-model="code" style="display: flex;">
                    </el-input>
                    <img :src="codeUrl" @click="changeCode()" style="min-width:100px; height:40px;"/>
                </div>
            </div>
            <div class="btn-wrap" style="text-align:center;">
                <el-button type="primary" style="width:200px;" @click="login()">{{msg('登录')}}</el-button> 
                <el-link style="margin-left:15px;" type="primary" href="reg">{{msg('注册新账户')}}</el-link>
            </div>
        </div>
    </el-dialog>

    </div>
</template>
<script>
import kit from "../plugins/kit.js";
export default {
    name: 'index1',
    data(){
        return{
            username: "",
            password: "",
            code:"",
            codeUrl: this.$kit.api.code, 
            imgUrl: this.$kit.api.imgView,
            companyInfo: {},
            loginVisiable:false,
        }
    }, 
    mounted:function(){
        window.document.title = "順運寶";
        var menu = document.querySelector(".n-menu");

        menu.addEventListener("click", function(e){
            if(e.target.classList.contains("n-menu-item")){
                var prev =  e.currentTarget.querySelector(".active");
                if(prev) prev.classList.remove("active");
                e.target.parentElement.classList.add("active");

                var btn = document.querySelector(".menu-btn");
                if(btn.style.display != 'none' && btn.style.display!=''){
                    menu.style.display = "none";
                }
                
            }
        });

        var menuBtn = document.querySelector(".menu-btn");
        menuBtn.addEventListener("click", function(e){
            var display = menu.style.display;
            if(display == 'flex'){
                menu.style.display = "none";
            }else{
                menu.style.display = "flex";
            }
        });
    },
    methods:{
        openLogin(){
            // this.username = "";
            // this.password = "";
            // this.code = "";
            // this.loginVisiable = true;
        },
        changeCode(){
            this.codeUrl =  this.$kit.api.code+"?"+new Date().getTime();
        },
        focusPwd(){
            this.$refs.pwdRef.focus();
        },
        focusCode(){
            this.$refs.codeRef.focus();
        },
        login(){
            var _this = this;

            if(!this.username){
                this.$message({type: 'info', message: '用户名不能为空' });
                return;
            }

            if(!this.password){
                this.$message({type: 'info', message: '密码不能为空' });
                return;
            }

            if(!this.code){
                this.$message({type: 'info', message: '验证码不能为空'});
                return;
            }

            var data =  {username: this.username, password: this.password, code: this.code};

            this.axios.post(kit.api.login, data).then(function (result) {
                //console.log(result); 
                if(result.status){
                //存数据，
                let user = result.data.user;
                let vipBalanceDay = user.vipBalanceDay;
                if(vipBalanceDay<=0){
                    user.vipDayTxt = "已到期";
                }else {
                    if(vipBalanceDay <= 31){
                    user.vipDayTxt = vipBalanceDay+"天";
                    }else {
                    user.vipDayTxt = (vipBalanceDay/31).toFixed()+"月";
                    }
                }

                localStorage.setItem("user", JSON.stringify(user));
                localStorage.setItem("token", result.data.token);
                
                localStorage.removeItem("locExpWarns");
                localStorage.removeItem("locErrExps");
                localStorage.removeItem("locTimeouts");
                

                _this.$router.push('/'); 

                }else{
                _this.$message({ type: 'warning', message: result.msg || "登录失败" });
                _this.changeCode();
                }

                
            }).catch(function (error) {
                console.error(error);
            });
        },
    }
}
</script>
<style scoped>
html, body{margin: 0px; padding: 0px; height: 100%; width:100%;}
body{
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji';
    line-height: 1.6;
    font-size: 16px;
    box-sizing: border-box;
}

ul{list-style:none; padding:0px;}
a{text-decoration: none; }

.nav-wrap  nav {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    position: fixed;
    width: 100%;
    background: rgba(70,100,254,0.9);
    box-shadow: 0px 3px 7px 0px rgb(68 90 208 / 50%);
    z-index: 20;
}

.n-left{
    display:flex;
    align-items: center;
    padding-top:15px; padding-left:15px; 
}

.n-logo-wrap img{width: 50px; }

.nav-wrap {
    background: url("../assets/images/bg.jpg") no-repeat;
    background-size:100% 100%;
    background-attachment:fixed;
}

.nav-bg{
    background-image: linear-gradient(to bottom, rgba(70,100,254,0.9) , rgba(112,132,254,0.9));
    max-height:780px; 
    height: 780px;
    
}

.n-left h1{margin: 0px; padding:0px; font-weight: bold; color: white; margin-left: 10px; white-space:nowrap; }

.n-menu li{padding: 5px; text-align:center; display:flex; flex-direction: column; align-items:center; }
.n-menu{display:flex;align-items: center;/* margin-top: 15px; */}
.n-menu a, .n-menu a:visited{color: rgba(208,215,255);font-weight:600;letter-spacing: 2px; white-space:nowrap; }
.n-menu a:hover, .n-menu a:active{color:white; }
.n-menu li:after{
    content: '';
    width: 0;
    height: 3px;
    background: rgba(252,190,0,1);
    display:block;
    text-align:center;
    margin-top:3px;
    animation: borderOutAni;
    animation-duration: 0.2s;
  
}

.n-menu li.active:after{
    width:100%;
}

.n-menu li.avtive:after, .n-menu li:hover:after{
    animation-name: borderInAni;
    animation-duration: 0.2s;
    animation-fill-mode: forwards;
}

.n-right{position:relative;}
.n-right .menu-btn{
    display: none;
    position: relative;
    top: 20px;
    margin-right:25px; 
}

.n-right .menu-btn svg{
    fill: rgba(208,215,255);
    cursor: pointer;
    
}
.n-right .menu-btn:hover svg{
    fill: white;
    cursor: pointer;
    
}

@keyframes borderInAni{
    from {width: 0;}
    to {width: 100%;}
}

@keyframes borderOutAni{
    from {width: 100%;}
    to {width: 0;}
}

.n-menu .n-menu-item-login a{display:flex; align-items: center; padding-right: 15px;
    color: rgba(252,190,0,1);                            
}
.n-menu-item-login svg {fill: rgba(252,190,0,1);}
.n-menu .n-menu-item-login{padding-top:0px;}
.n-menu .n-menu-item-login:after{
    display:none;
}

.n-menu .n-menu-item-login a:hover{
    color: rgba(252,205,60,1);    
}
.n-menu .n-menu-item-login a:hover svg{fill:rgba(252,205,60,1); }

.banner-wrap > div{
    display:flex; justify-content: space-around;
    align-items: center;
    flex-wrap: nowrap;
}

.b-icon img{width: 600px; opacity: 0.7;}
.b-title h2, .b-title p{white-space:nowrap; padding-left: 40px; }

.b-title{color: white; }

.find, .desc, .develop{width: 100%; margin: 0px auto;}
.find-wrap, .desc-wrap, .develop-wrap{width: 1100px; margin:0px auto; text-align: left;}
.sub-head {
    text-align: center;  border-bottom:2px solid rgba(70,100,254,0.2);
    font-size: 20px; font-weight: 600; padding: 15px;
    letter-spacing: 3px;
    color: rgba(70,100,254,1);
}

.find-content ul{display: flex;flex-wrap: wrap;/* justify-content: center; */align-items: center;box-sizing: border-box;/* text-align: center; */margin-left: 8px;}
.find-content li{flex: 0 0 33%;padding: 10px 0px;border: 1px solid #eee;cursor:pointer;height: 96px;box-sizing: border-box;}
.find-content li:hover {background: #eee;}
.find-content li a,  .find-content li a:visited, .find-content li a:active{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #666;
        font-weight: 500;
        height: 76px;
}

.find-content li a:hover{
   color: rgba(70,100,254,1);
}
.find-content li a:hover img{
    animation-name: angleAni;
    animation-duration: 1s;
}

@keyframes angleAni{
    0%{transform: rotateY(0deg);}
    50%{transform: rotateY(360deg);}
    100%{transform: rotateY(0deg);}
}

.find-content a img{
    max-width: 100px;
    max-height: 50px;
}


.desc{
    background-image: linear-gradient(to left bottom, rgb(83 117 239), rgb(188 198 247));
    width: 100%; overflow:hidden; position:relative;
    box-sizing: border-box;
    margin-top: 45px;
}



.desc:before, .desc:after {
    content: "";
    width: 300px;
    height: 300px;
    display:inline-block;
    position: absolute;
    z-index: 1;
    border-radius: 50%;
    box-shadow: -2px 2px 20px 0px rgba(51, 92, 238,0.5);
    animation-name: myTranslate1;
    animation-duration: 3s;
    animation-timing-function: ease;
    animation-iteration-count: infinite;
    animation-direction: alternate;
}

.desc:before {
    top:-120px;
    right: -120px;
    background: rgb(51 92 238);
    box-shadow: -2px 2px 20px 0px rgba(51, 92, 238,0.5);
    animation-name: myTranslate1;
    animation-duration: 3s;
    animation-timing-function: ease;
    animation-iteration-count: infinite;
    animation-direction: alternate;
}

.desc:after {
    width: 200px;
    height: 200px;
    left:-100px;
    bottom: -100px;
    background: rgb(107 135 236);
    box-shadow: 2px -2px 20px 0px rgba(51, 92, 238,0.5);
    animation-name: myTranslate2;
    animation-duration: 3s;
    animation-timing-function: ease;
    animation-iteration-count: infinite;
    animation-direction: alternate;

}

.desc-head{position: relative; z-index: 2; color: white; border-color: white;}
.desc-inner{position: relative; z-index: 2;
    display: flex; justify-content: space-around; 
    
}

.desc-inner > * {
    flex: 50%;
    box-sizing: border-box;
    background: white;
    margin: 0px 20px 35px 0px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 0px rgba(51, 92, 238,1);
}

.desc-inner p{display: flex;  flex-direction: column; 
    align-items: center; font-size: 30px;   color:#333;
}

.desc-inner p svg{
    fill: #0082ff;
}

    
.desc-inner ul {display: flex; flex-wrap: wrap; padding: 0px 20px 20px 20px; 
                margin:0px;}
.desc-inner li{padding: 1px 8px; color: #666;}

.dev-content ul{display:flex; }
.div-content li{display: flex; }



@keyframes myTranslate1{
    0%{transform: translate(0px, 0px);}
    100%{transform: translate(20px, -20px);}
}

@keyframes myTranslate2{
    0%{transform: translate(0px, 0px);}
    100%{transform: translate(-20px, 20px);}
}

.develop-wrap{
    background: #f6f7fb;
}

.dev-head{
    display: flex; border-bottom-width: 0px;
    flex-direction: column;
    padding:20px; margin:0px;

}
.dev-title{ border-bottom:2px solid rgba(70,100,254,0.2); padding-bottom: 15px;}
.dev-subtitle{font-size: 16px; text-align:left; color:#888;
    font-weight:500; padding-top:10px;
}

.dev-content ul{display:flex; justify-content: space-around; }
.dev-content li{display: flex; flex-direction: column; flex: 0 0 33%;
    box-sizing: border-box; padding: 0px 15px; margin: 15px 0px;
    align-items: center;
}

.dev-content li svg{fill:red;}
.dev-content li p{margin: 8px; font-size: 18px; font-weight: 500px; color: #333;}
.dev-content li span{font-size: 14px; color: #888;}

.footer{width: 100%; text-align:center; margin: 0px auto;
    background: #242328;
}
.footer-wrap{width: 1100px; margin: 0px auto; 
             text-align:center; padding-top: 15px;
}
.contact-head{font-size: 20px; color: white;}
.contact-head1{font-size: 15px; color: #cfd2d5;}
.ct-img-wrap{margin-bottom: 15px;}
.ct-img-wrap img{width: 150px;}
.bk{padding: 15px; font-size: 15px; color: #525354; text-align: center;}
.bk a, .bk a:visited, .bk a:active{color: #525354; margin-left: 15px;}

@media (max-width: 900px) {
    .b-title{position: absolute; text-shadow: 2px 2px #333; z-index: 3; }
    .b-title h2{font-size: 32px;}
    .b-title p{font-size:24px;}
}

@media (min-width: 900px) {
    .b-title{position: absolute; text-shadow: 2px 2px #333; z-index: 3; }
    .b-title h2{font-size: 36px;}
    .b-title p{font-size:28px;}
}

@media (min-width: 1100px) {
    .b-title{position: static;  }
    .b-title h2{font-size: 28px;}
    .b-title p{font-size:20px;}
}

@media (min-width: 1300px) {
    .b-title h2{font-size: 32px;}
    .b-title p{font-size:24px;}
}

@media (max-width: 1100px) {
    .find-wrap, .desc-wrap, .develop-wrap{width: 100%;}
}

@media (max-width: 700px) {
    .b-title{
        position:absolute;
        /* left: 30px; */
        z-index: 10;
    }
}

@media (max-width: 600px) {
    
    .n-right .menu-btn {
        display: inline-block;
    }
    .n-right{position: relative;}
    .n-menu{
        display: none;
        flex-direction: column;
        background: white;
        position: absolute;
        right: 20px;
        align-items: flex-start; 
        z-index: 10;
        box-shadow: 0px 3px 10px 10px rgb(145 155 207 / 0.2);
        
    }
    .n-menu li{padding: 0px; width:100%; text-align:left; box-sizing: border-box; }
    .n-menu{padding-top: 5px; padding-bottom: 5px;}
    .n-menu a{padding: 0px 10px; display: block; width:100%; box-sizing: border-box;}

    .n-menu a, .n-menu a:visited, .n-menu a:active{color: #666;}
    .n-menu a:hover{color: rgba(70,100,254,0.9); }
    .b-title h2, .b-title p{margin: 0px; padding: 0px; text-align: center; text-shadow: 2px 2px #333;}
    .b-icon img{width: 100%;}
    .nav-bg{height: 500px;}

    .find-wrap, .desc-wrap, .develop-wrap{width: 100%;}
    .find-content li{flex: 0 0 49%;}
    .desc-inner{
        box-sizing: border-box; margin-left: 20px; flex-wrap: wrap;
    }
    .desc-inner > *{flex: 0 0 100%; }
    .footer-wrap{width: 100%;}
    
    .b-title h2{font-size: 24px;}
    .b-title p{font-size: 18px;}
}

.login-alert{
    position: fixed;
    left:0px; top: 0px;
    z-index: 20;
    background: rgba(0,0,0,0.4);
    width:100vw;
    height:100vh;
}

.login-alert-shadow{
    display:flex;
    align-items:center;
    justify-content:center;
    height:calc(100vh - 200px);
    
}

.login-wrap{
    background: white;padding: 20px;
    border-radius: 6px;
    box-shadow: 0px 0px 15px 0px rgba(0,0,0, 0.2);
}

.login-title{text-align:center; font-size:20px; letter-spacing: 8px; font-weight: 600; color:#333; margin-bottom: 10px;}

.form-line{display: flex; padding: 10px; align-items:center; }

.form-line > span{display:inline-block; width:80px;text-align:right;
    font-size:16px; font-weight:500; letter-spacing: 2px;        
}

.form-line input[type='text'], .form-line input[type='password']{
    padding: 7px 10px; outline:none; 
    border: 1px solid #999;
    width:200px;
}

.form-line input[type='text']:focus, .form-line input[type='password']:focus{
    border-color: #409eff;
    box-shadow: 0px 0px 3px 0px #409eff;
}

.form-line.code-line input{width: 116px;}
.code-line img{height:33px;}

.form-line.err-info{
    display: block;
    text-align:center;
    font-size:14px; letter-spacing: 1.5px;
    color: #f53333;
    padding:5px;
}

.form-line.btn-line{
    display:block;
    text-align:center;
}
.btn-line button{
    border: 0px;
    opacity: 0.85;
    font-size:16px; letter-spacing: 3px;
    padding: 8px 25px;
    cursor: pointer;
    color: white;
}

#enter-btn{
    background :#409eff;
}
#exit-btn{
    background :#f53333;
    margin-left:15px;
}

.btn-line button:hover{
    opacity: 1;
}
</style>